import React from "react";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { useLocation } from "react-router-dom";

import { handlePhotoError } from "../../utils/profilePhoto";


function ProfileSideBar() {

    const { firstName, lastName, avatar } = useCurrentUser();
    const location = useLocation();
    const showStats = location.pathname.startsWith("/survey-results/");
    
  return (
    <div className="sidebar-card mb-4 text-center">
        <img src={avatar} onError={handlePhotoError} alt="Profile" className="user-img mb-3 mx-auto" />

        {firstName && (
          <h2 className="fw-bold ft-22 mb-2">
            {`${firstName} ${lastName}`}
          </h2>
        )}

        <div className="active-badge ft-12 fw-bold">&bull; Active Explorer</div>

        {/* Keep the social section available, but hide it and its divider. */}
        <hr className={`my-4 ${showStats ? "" : "d-none"}`} />

        <div className={`row user-stats text-center ${showStats ? "" : "d-none"}`}>
          <div className="col-4">
            <h4>128</h4>
            <p>Posts</p>
          </div>

          <div className="col-4">
            <h4>4.8k</h4>
            <p>Followers</p>
          </div>

          <div className="col-4">
            <h4>312</h4>
            <p>Following</p>
          </div>
        </div>
      </div>
  );
}

export default ProfileSideBar;
